import React, { useEffect, useState } from "react";
import { Col, Dropdown, DropdownButton } from "react-bootstrap";
import { connect, useDispatch, useSelector } from "react-redux";
import useLoading from "../hooks/useLoading";
import { getBotDetail, getBots, getIndicators, getRentalBots, activeBot, deleteBot, bulkUpdateBots } from "../../actions/bot-action";
import { resetBotConfig, updateCopyBotConfig, updateEditBotConfig, updateEditRentBotConfig } from "../../actions/create-bot-action";
import { useHistory, useLocation } from "react-router-dom";
import { CREATE_BOT_START } from "../../actions/create-bot-type";
import queryString from "query-string";
import ReactStatePagination from "../common/ReactStatePagination";
import { BOTS_ACTIVE_TAB, BOTS_ORDER_BY, BOTS_ITEMS_PER_PAGE, BOTS_SORT, RESET_BOT_PAGE_NUMBERS } from "../../actions/types";
import { toast } from "react-toastify";
import BotCard from "./BotCard";
import BotListEmpty from "./BotListEmpty";
import BotTableView from "./BotTableView";
import BulkActionPanel from "./BulkActionPanel";


const BotList  = (props)=>{
    const {t,getBots,getBotDetail,updateCopyBotConfig,updateEditBotConfig,getIndicators,resetBotConfig,updateEditRentBotConfig,searchBotName, viewMode, activeBot, deleteBot, bulkUpdateBots} = props
    const { search } = useLocation();
    const query = queryString.parse(search)
    const history = useHistory()
    const dispatch = useDispatch()
    const [setLoading, bindLoading] = useLoading(false);
    const [selectedBotIds, setSelectedBotIds] = useState([]);
    const [clientStatusOrderBy, setClientStatusOrderBy] = useState(null);
   
    let bots = useSelector((state) => state.bots.bots) || [];
    const totalBots = useSelector((state) => state.bots.totalBots) || 0;
    const startItem = useSelector((state) => state.bots.startItem) || 1;
    const selectedExchangeId = useSelector((state) => state.settings.selectedExchangeId) || 0;
    const status = useSelector((state) => state.pagination.botsActiveTab) || "all";
    const sort = useSelector((state) => state.pagination.botSort) || "name";
    const orderBy = useSelector((state) => state.pagination.botsOrderBy) || "desc";
    const pageNumbers = {
      "active":useSelector((state) => state.pagination.botsActivePage),
      "inactive":useSelector((state) => state.pagination.botsInactivePage),
      "all":useSelector((state) => state.pagination.botsPageAll),
    }
    bots = bots.filter((item) => {
        return selectedExchangeId == item.exchange_id;
      });
    const itemsPerPage = useSelector((state) => state.pagination.botItemsPerPage) || 12;
    const getBotStatusVariant = (bot) => {
      if (bot.deal_status === 1) {
        return "active";
      }
      if (bot.status === "inactive") {
        return "inactive";
      }
      if (bot.status === "active" || bot.deal_status === 2) {
        return "waiting";
      }
      return "inactive";
    };
    const getBotStatusRank = (bot) => {
      const statusVariant = getBotStatusVariant(bot);
      if (statusVariant === "inactive") {
        return 0;
      }
      if (statusVariant === "waiting") {
        return 1;
      }
      return 2;
    };

    const changeItemsPerPage = (itemsPerPage) => {
        dispatch({ type: BOTS_ITEMS_PER_PAGE, payload: itemsPerPage });
        dispatch({ type: RESET_BOT_PAGE_NUMBERS });
    };
    
    // Clear selection when bots list changes (e.g. pagination/filter/exchange change)
    useEffect(() => {
        setSelectedBotIds([]);
    }, [selectedExchangeId, status, pageNumbers[status]]);

    useEffect(() => {
      if (clientStatusOrderBy) {
        setClientStatusOrderBy(null);
      }
    }, [sort, orderBy]);
    
    const handleSelect = (id) => {
        if (selectedBotIds.includes(id)) {
            setSelectedBotIds(selectedBotIds.filter(itemId => itemId !== id));
        } else {
            setSelectedBotIds([...selectedBotIds, id]);
        }
    };

    const handleSelectAll = (isChecked) => {
        if (isChecked) {
            const allIds = displayBots.map(b => b.id);
            setSelectedBotIds(allIds);
        } else {
            setSelectedBotIds([]);
        }
    };

    const handleBulkAction = (action) => {
        if (selectedBotIds.length === 0) return;
        setLoading(true);
        bulkUpdateBots(selectedBotIds, action, selectedExchangeId, itemsPerPage, pageNumbers[status], status, orderBy, sort)
            .then((res) => {
                toast.success(res.message || "Bulk action completed");
                setSelectedBotIds([]); // Clear selection on success
                setLoading(false);
            })
            .catch((err) => {
                toast.error(err);
                setLoading(false);
            });
    };
    
  const paginationCallback = (pageNum)=>{
    getBots(selectedExchangeId,itemsPerPage,pageNum,status,orderBy,sort);
  }
    const botAction = (botId,action) => {
      setLoading(true);
      getBotDetail(botId)
        .then((res) => {
          if(!res.rent_id){
            if(action==="edit"){
                updateEditBotConfig();
            }
            if(action==="copy"){
              updateCopyBotConfig(botId);
            }
            dispatch({
              type: CREATE_BOT_START,
              payload: true,
            });
            history.push(`/bots/create`);
          }
          else{
            if(action==="edit"){
              dispatch({
                type: CREATE_BOT_START,
                payload: true,
              });
              updateEditRentBotConfig()
              history.push(`/rent/create`);
            }
            else{
                toast.error("Not available for rental bots");
            }
          }
            setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          toast.error(err);
        });
    };
    useEffect(() => {
      getBots(selectedExchangeId,itemsPerPage,searchBotName?1:pageNumbers[status],status,orderBy,sort,searchBotName);
      getIndicators();
      resetBotConfig();
    }, [status,sort,orderBy,selectedExchangeId,searchBotName,itemsPerPage]);

    let displayBots = bots.map((bot) => ({
      ...bot,
      statusVariant: getBotStatusVariant(bot),
    }));

    if (clientStatusOrderBy) {
      displayBots = [...displayBots].sort((bot1, bot2) => {
        const rankDiff = getBotStatusRank(bot1) - getBotStatusRank(bot2);
        return clientStatusOrderBy === "asc" ? rankDiff : -rankDiff;
      });
    }

    const rows = displayBots
    .map((bot, index) => {
      const clickBotAction = (type) => {
        botAction(bot.id,type);
      };
      return (
       <BotCard key={bot.id} bot={bot} clickBotAction={clickBotAction} itemsPerPage={itemsPerPage} pageNum={pageNumbers[status]} selectedTab={status} 
        selectable={true}
        isSelected={selectedBotIds.includes(bot.id)}
        onToggleSelect={handleSelect}
       ></BotCard>
      );
    });

    const isTableView = viewMode === "table";

    return(
        <>
        <Col xs={2}>
          {totalBots > 0 && (
              <div className="d-flex align-items-center mt-3 mb-2">
                <span className="me-2 " style={{whiteSpace: 'nowrap'}}>{t ? (t("bots_per_page") || "Bots per page:") : "Bots per page:"}</span>
                <select 
                    className="form-select form-select-sm" 
                    style={{ width: 'auto', display: 'inline-block' }}
                    value={itemsPerPage} 
                    onChange={(e) => changeItemsPerPage(Number(e.target.value))}
                >
                    {[12, 20, 25, 30, 35, 40, 45, 50].map(num => (
                        <option key={num} value={num}>{num}</option>
                    ))}
                </select>
            </div>
          )}
        </Col>
        <Col xs={10}>
             <BulkActionPanel 
                selectedCount={selectedBotIds.length} 
                onAction={handleBulkAction} 
                onClear={() => setSelectedBotIds([])} 
             />
            
        </Col>
        

        {displayBots.length === 0 ? <Col xs={12}><BotListEmpty selectedTab={status}></BotListEmpty></Col> : (
            isTableView ? (
                <Col xs={12}>
                    <BotTableView 
                        bots={displayBots}
                        selectedIds={selectedBotIds}
                        onSelect={handleSelect}
                        onSelectAll={handleSelectAll}
                        clickBotAction={(id, type) => botAction(id, type)}
                        activeBot={activeBot}
                        deleteBot={deleteBot}
                        t={t}
                        itemsPerPage={itemsPerPage}
                        pageNum={pageNumbers[status]}
                        selectedTab={status}
                        selectedExchangeId={selectedExchangeId}
                        orderBy={orderBy}
                        sort={sort}
                        clientStatusOrderBy={clientStatusOrderBy}
                        onStatusSort={() => {
                          setClientStatusOrderBy((prev) => {
                            if (!prev) {
                              return "desc";
                            }
                            return prev === "asc" ? "desc" : "asc";
                          });
                        }}
                        userId={1} 
                    />
                </Col>
            ) : (
                rows
            )
        )}
       
        <div className="bottom-center ">
          <ReactStatePagination
            itemsCountPerPage={itemsPerPage}
            forPage="bots"
            startItem={startItem}
            selectedTab={status}
            totalCount={totalBots}
            onChange={paginationCallback}
            itemsPerPage={itemsPerPage}
          /> 
          
        </div>
        </>
    )
}

export default connect(null,{getBots,getRentalBots,getBotDetail,updateCopyBotConfig,updateEditBotConfig,resetBotConfig,getIndicators,updateEditRentBotConfig, activeBot, deleteBot, bulkUpdateBots}) (BotList);
